import React, { useState, useContext, useEffect, useMemo } from 'react'
import { useLocation, useNavigate, useSearchParams  } from "react-router-dom";
import { useAliveController } from 'react-activation'
import { Dropdown, message, ConfigProvider, Button } from 'antd'
import { SearchOutlined } from '@ant-design/icons';
import MainContext from '@/stores/stores'
import { useIntl } from 'react-intl'
import styles from './index.module.scss'
import LogoImg from './LogoImg'
import accountApi from '@/api/accountApi';
import VinInput from "@/components/VinInput"
import { strEncrypt, getDecryptParams } from '@/utils/utils'
import IMChat from '@/pages/IMChat'
import { enToCn } from '@/utils/china-geo-map';

const HeaderSix: React.FC<any> = (props) => {
  const token = localStorage.getItem("token") || ''
  const { headerInfo = {} } = props
  const config = headerInfo.config ? headerInfo.config : {}
  const { pathname } = useLocation()
  const navigate = useNavigate()
  const [searchParams, setSearchParams] = useSearchParams()
  let params = searchParams.get("params")
  const intl = useIntl()
  const { refreshScope, clear, dropScope, drop, refresh  } = useAliveController()
  const { commonStore, setCommonStore } = useContext(MainContext)
  const { userInfo, isWomala, host, colorPrimary, fontColorPrimary, canLang, isCst, distributorInfo, hasFreeVin, sxSetData  } = commonStore

  let domain = window.location.host
  const lang: any  = window.localStorage.getItem('lang')

  const [vinInputKey, setVinInputKey] = useState<string>('')

  const [isMobile, setIsMobile] = useState<boolean>(false)

  const [classList, setClassList] = useState<any[]>([])
  const [groupClass, setGroupClass] = useState<any>({})
  const [selClass, setSelClass] = useState<string>("")
  const [secondClass, setSecondClass] = useState<string>("")
  const [classShow, setClassShow] = useState<boolean>(false)
  const [hasSecondClass, setHasSecondClass] = useState<boolean>(false)

  const [parts_categories_zone, set_parts_categories_zone] = useState<any[]>([])

  const [selTags, setSelTags] = useState<string>('')
  const [selHeaderClass, setSelHeaderClass] = useState<string>('')

  const [merchantList, setMerchantList] = useState<any[]>([])
  const [merchantItem, setMerchantItem] = useState<any>({})

  useEffect(() => {
    getSecondClass()
    isModernPhone().then((isTrue: boolean) => {
      setIsMobile(isTrue)
    })
  }, [])

  useEffect(() => {
    if(commonStore.query_mode) {
      getMerchantList()
    }
  }, [commonStore.query_mode])
  useEffect(() => {
    let config = headerInfo.config ? headerInfo.config : {}
    let _parts_categories_zone = config.data ? config.data : []
    set_parts_categories_zone(_parts_categories_zone)
    if(params) {
      let paramsObj = getDecryptParams(params)
      let tags = paramsObj.tags ? paramsObj.tags : ''
      let index = parts_categories_zone.findIndex((ele: any) => {
        if(tags && ele.tags) {
          let _tags = ele.tags.map((el: any) => el.name)
          let _tags_msg = _tags.join(',')
          if(_tags_msg === tags) {
            return true
          }else {
            return false
          }
        }else {
          return false
        }
      })
      if(index !== -1) {
        let _parts_categories_zone_item = _parts_categories_zone[index]
        setSelHeaderClass(_parts_categories_zone_item.name)
      }
    }
  }, [headerInfo, isMobile, lang, params])

  useEffect(() => {
    if(params) {
      let paramsObj = getDecryptParams(params)
      if(paramsObj.vin) {
        setVinInputKey(paramsObj.vin)
      }else if(paramsObj.brand && !paramsObj.vin) {
        setVinInputKey(paramsObj.brand)
      }else if(paramsObj.en_plate) {
        setVinInputKey(paramsObj.en_plate)
      }else if(paramsObj.oeList) {
        setVinInputKey(paramsObj.oeList)
      }else {
        setVinInputKey('')
      }
    }else {
      setVinInputKey('')
    }
    // if((commonStore.pageType === '6' || commonStore.pageType === '7') && pathname === '/cjh') {
    if(pathname === '/cjh') {
      // setOeKeyword('')
      if(params) {
        let paramsObj = getDecryptParams(params)
        console.log("paramsObj666:", paramsObj)
        if(paramsObj.class) {
          let _classArr = paramsObj.class.split(',')
          let class1 = _classArr[0].replace(/\+/, "&")
          let class2 = _classArr[1] ? _classArr[1].replace(/\+/, "&") : ''
          setSelTags('')
          setSelHeaderClass('')
          setSelClass(class1)
          setSecondClass(class2)
        }else {
          setSelClass('')
          setSecondClass('')
        }
        if(paramsObj.tags) {
          setSelClass('')
          setSecondClass('')
          setSelTags(paramsObj.tags)
          if(parts_categories_zone.length) {
            let index = parts_categories_zone.findIndex((ele: any) => {
              if(paramsObj.tags && ele.tags) {
                let _tags = ele.tags.map((el: any) => el.name)
                let _tags_msg = _tags.join(',')
                if(_tags_msg === paramsObj.tags) {
                  return true
                }else {
                  return false
                }
              }else {
                return false
              }
            })
            if(index !== -1) {
              let _parts_categories_zone_item = parts_categories_zone[index]
              setSelHeaderClass(_parts_categories_zone_item.name)
            }
          }
        }else {
          setSelTags('')
          setSelHeaderClass('')
        }
      }else {
        setSelClass('')
        setSecondClass('')
        setSelTags('')
        setSelHeaderClass('')
      }
    }
    
  }, [pathname, params, parts_categories_zone])

  const getCityByIp = async () => {
    try {
      const res = await fetch('https://hackmyip.com/api/ip');
      const data = await res.json();
      let location = data.data && data.data.location ? data.data.location : {}
      console.log("getCityByIp location:", location)
      let latitude = location.latitude
      let longitude = location.longitude
      let city = location.city
      return city;
    } catch (e) {
      console.error('定位失败', e);
      return null;
    }
  }
  const getMerchantList = async () => {
    try {
      let city = await getCityByIp()
      console.log("city:", city)
      let res = await accountApi.getMerchantList()
      if(res.code === 1) {
        let _data = res.data ? res.data : []
        setMerchantList(_data)
        let stock_merchant_id = sessionStorage.getItem('stock-merchant-id') || ''
        if(!stock_merchant_id) {
          if(_data.length) {
            let cityCN = enToCn(city)
            console.log("cityCN:", cityCN)
            let index = _data.findIndex((ele: any) => ele.province_city.includes(cityCN))
            let _item = index === -1 ? _data[0] : _data[index]
            setMerchantItem(_item)
            sessionStorage.setItem('stock-merchant-id', _item.merchant_id)
          }else {
            sessionStorage.setItem('stock-merchant-id', '')
            setMerchantItem({})
          }
        }else {
          if(_data.length) {
            let index = _data.findIndex((ele: any) => ele.merchant_id === stock_merchant_id)
            let _item = index === -1 ? _data[0] : _data[index]
            setMerchantItem(_item)
            sessionStorage.setItem('stock-merchant-id', _item.merchant_id)
          }else {
            sessionStorage.setItem('stock-merchant-id', '')
            setMerchantItem({})
          }
        }
      }
    }catch(err) {
      sessionStorage.setItem('stock-merchant-id', '')
      setMerchantItem({})
    }
  }

  const isModernPhone = async () => {
    // 新标准设备检测 API (Chrome 89+)
    let _navigator: any = navigator
    if (_navigator.userAgentData) {
      const { mobile, platform } = await _navigator.userAgentData.getHighEntropyValues(
        ['mobile', 'platform']
      );
      // Android/iOS 平台 + 移动标志
      if (mobile && ['Android', 'iOS'].includes(platform)) {
        const deviceMemory = _navigator.deviceMemory || 0;
        return deviceMemory <= 8; // 排除高性能平板
      }
    }
    
    // 降级处理：屏幕尺寸 + 用户代理验证
    const maxDimension = Math.max(window.screen.width, window.screen.height);
    return maxDimension < 1000 && /Mobile/i.test(_navigator.userAgent);
  }

  const getSecondClass = () => {
    accountApi.getSecondClass({
      is_hide: 1
    }).then((res: any) => {
      if(res.code === 1) {
        let images_dict = res.data && res.data.images_dict ? res.data.images_dict : {}
        let standard_maingroup = res.data && res.data.standard_maingroup ? res.data.standard_maingroup : []
        setClassList(standard_maingroup)
        if(Object.keys(res.data.standard_subgroup_name).length) setHasSecondClass(true)
        setGroupClass(res.data.standard_subgroup_name)
      }
    })
  }
  const classItems: any[] = useMemo(() => {
    if(classList.length > 6) {
      let _classItems = classList.slice(6).map((item: any, index: number) => {
        return {
          label: <div className='pointer' onClick={() => classItemClick(item, index + 7)}>{item}</div>,
          value: item
        }
      })
      return _classItems
    }else {
      return []
    }
  }, [classList, hasSecondClass])
  const getPartCateZone = () => {
    let domain = window.location.host
    const lang: any  = window.localStorage.getItem('lang')
    accountApi.getHomeDataThree({ 
      domain: host || domain,
      lang 
    }).then((res: any) => {
      setCommonStore({
        type: 'isGetFreeCjh',
        value: true
      })
      if(res.code === 1) {
        let _parts_categories_zone = res.data && res.data.parts_categories_zone ? res.data.parts_categories_zone : []
        set_parts_categories_zone(_parts_categories_zone)
        if(params) {
          let paramsObj = getDecryptParams(params)
          let tags = paramsObj.tags ? paramsObj.tags : ''
          let index = _parts_categories_zone.findIndex((ele: any) => tags && ele.config && ele.config.tags && ele.config.tags === tags)
          if(index !== -1) {
            let _parts_categories_zone_item = _parts_categories_zone[index]
            setSelHeaderClass(_parts_categories_zone_item.name)
          }
        }
        let dataVin = res.data && res.data.vin ? res.data.vin : []
        let contract2 = res.data && res.data.contract2 ? res.data.contract2 : {}
        if(lang) {
          let item = contract2[lang] ? contract2[lang] : {}
          setCommonStore({ value: item, type: 'webData' })
        }
        setCommonStore({ value: dataVin.length ? true : false, type: 'hasFreeVin'})
        setCommonStore({ value: res.data.name, type: 'siteName' })
        setCommonStore({
          value: dataVin,
          type: 'freeCjhList'
        })
        setCommonStore({
          value: res.data && res.data.epc_brands ? res.data.epc_brands : {},
          type: 'epc_barnds'
        })
      }
    })
  }

  const setLang = (lang: "zh" | "en" | "ru" | "cht" | "tr" | "ara" | "pt" | "vie" | "fra" | "kor") => {
    setSearchParams({})
    window.localStorage.setItem('lang', lang)
    window.location.href = "/home"
  }

  const langItems: any = [
    {
      key: 'zh',
      label: (
        <div className="flex-s-c" onClick={() => setLang('zh')}>
          中文
        </div>
      )
    },
    {
      key: 'en',
      label: (
        <div className="flex-s-c" onClick={() => setLang('en')}>
          English
        </div>
      )
    },
    {
      key: 'ru',
      label: (
        <div className="flex-s-c" onClick={() => setLang('ru')}>
          Русский язык
        </div>
      )
    },
    {
      key: 'fra',
      label: (
        <div className="flex-s-c" onClick={() => setLang('fra')}>
          French
        </div>
      )
    },
    {
      key: 'cht',
      label: (
        <div className="flex-s-c" onClick={() => setLang('cht')}>
        中文-繁體
        </div>
      )
    },
    {
      key: 'tr',
      label: (
        <div className="flex-s-c" onClick={() => setLang('tr')}>
        Türkiye
        </div>
      )
    },
    {
      key: 'ara',
      label: (
        <div className="flex-s-c" onClick={() => setLang('ara')}>
          بالعربية
        </div>
      )
    },
    {
      key: 'pt',
      label: (
        <div className="flex-s-c" onClick={() => setLang('pt')}>
          Português
        </div>
      )
    },
    {
      key: 'vie',
      label: (
        <div className="flex-s-c" onClick={() => setLang('vie')}>
          Tiếng Việt
        </div>
      )
    },
    {
      key: 'kor',
      label: (
        <div className="flex-s-c" onClick={() => setLang('kor')}>
          한국어
        </div>
      )
    },
    /* {
      key: 'may',
      label: (
        <div className="flex-s-c" onClick={() => setLang('may')}>
          Bahasa Melayu
        </div>
      )
    },
    {
      key: 'th',
      label: (
        <div className="flex-s-c" onClick={() => setLang('th')}>
          ภาษาไทย
        </div>
      )
    },
    {
      key: 'id',
      label: (
        <div className="flex-s-c" onClick={() => setLang('id')}>
          Bahasa Indonesia
        </div>
      )
    },
    {
      key: 'pl',
      label: (
        <div className="flex-s-c" onClick={() => setLang('pl')}>
          Polski
        </div>
      )
    } */
  ].filter((item: any) => canLang && canLang.includes(item.key))

  const merchantItems: any = useMemo(() => {
    let _items = merchantList.map((item: any) => {
      return {
        key: item.merchant_id,
        label: (
          <div 
            className="flex-s-c" 
            onClick={() => {
              setMerchantItem(item); 
              window.sessionStorage.setItem('stock-merchant-id', item.merchant_id)
              window.location.href = "/home"}
            }
          >
            {item.erp_company}
          </div>
        )
      }
    })
    return _items
  }, [merchantList])

  const toHome = () => {
    navigate('/home')
  }

  const navigateTo = (url: string) => {
    if(localStorage.getItem('token') && (!localStorage.getItem('tourist_user'))) {
      navigate(url)
    }else {
      navigate('/login')
    }
  }

  const classItemClick = (item: any, index: number) => {
    if(hasSecondClass) {
      if(selClass === item) {
        setSelTags('')
        setSelHeaderClass('')
        setSelClass('')
      }else {
        setSelTags('')
        setSelHeaderClass('')
        setSelClass(item); 
      }
      let navPath: any = document.getElementById(`navPath${index + 1}`)
      navPath?.scrollIntoView({ behavior: 'smooth' });
    }else {
      if(token) {
        if((!localStorage.getItem('tourist_user')) && (commonStore.userInfo && commonStore.userInfo.verify_status && commonStore.userInfo.verify_status !== 1) || (commonStore.userInfo && !commonStore.userInfo.verify_status)) {
          message.warning(intl.formatMessage({ id: "暂无权限" }))
          return false
        }
        
        try {
          clear()
        }catch(err: any) {
          
        }
        let params1 = searchParams.get('params')
        let paramsObj: any = {}
        if(params1) {
          paramsObj = getDecryptParams(params1)
        }
        paramsObj.class = item
        if(paramsObj.tags) {
          setSelTags('')
          setSelHeaderClass('')
          delete paramsObj.tags
        }
        let _searchParams = strEncrypt(paramsObj)
        setTimeout(() => {
          navigate(`/cjh?params=${_searchParams}&vinkey=${new Date().getTime()}`)
        },100)
      }else {
        message.warning(intl.formatMessage({ id: "请先登录" }))
        navigate('/login')
      }
    }
    
  }

  const capitalizeFirstLetter = (string: string) => {
    if(localStorage.getItem('lang') === 'en' && string) {
      return string.split(' ').map((word: string) => {
        return word.charAt(0).toUpperCase() + word.slice(1);
      }).join(' ');
    }else {
      return string
    }
  }

  const gotoClass = (item: any) => {
    if(token) {
      if((!localStorage.getItem('tourist_user')) && (commonStore.userInfo && commonStore.userInfo.verify_status && commonStore.userInfo.verify_status !== 1) || (commonStore.userInfo && !commonStore.userInfo.verify_status)) {
        message.warning(intl.formatMessage({ id: "暂无权限" }))
        return false
      }
      
      try {
        clear()
      }catch(err: any) {
        
      }
      let params1 = searchParams.get('params')
      let paramsObj: any = {}
      if(params1) {
        paramsObj = getDecryptParams(params1)
      }
      paramsObj.class = item.title
      if(paramsObj.tags) {
        setSelTags('')
        setSelHeaderClass('')
        delete paramsObj.tags
      }
      let _searchParams = strEncrypt(paramsObj)
      setTimeout(() => {
        // navigate(`/class?params=${strEncrypt({class: item.title})}`)
        navigate(`/cjh?params=${_searchParams}&vinkey=${new Date().getTime()}`)
      },100)
    }else {
      message.warning(intl.formatMessage({ id: "请先登录" }))
      navigate('/login')
    }
    setClassShow(false)
  }
  return (
    <>
      <div className={styles['header9']}>
        <div className={styles['hb-boot']}>
          <div className={styles['ht-9']}>
            <div className={styles['ht-l']}>
              {
                token && (!localStorage.getItem('tourist_user')) && commonStore.imChatData.appKey ? <div className={styles['header-logo'] + ' pointer'}>
                  <LogoImg style={{maxWidth: config.logo_width, maxHeight: config.logo_height}} src={config.logo || ""}/>
                </div> : <div className={styles['header-logo'] + ' pointer'} onClick={toHome}>
                  <img src={config.logo || ""} alt="" />
                </div>
              }
            </div>
            <div className={styles['ht-m']}>
              <ConfigProvider
                theme={{
                  token: {
                    /* 这里是你的全局 token */
                    colorBorder: colorPrimary,
                  },
                }}
              >
                <VinInput
                  placeholder={commonStore.headerInfo && commonStore.headerInfo.model_checked ? intl.formatMessage({id: '请输入OE/零件名称搜索'}) : intl.formatMessage({id: '搜索'})}
                  size="large"
                  width={580}
                  wrapStyle={{marginRight: 10, marginLeft: 10}}
                  style={{background: 'rgba(255, 255, 255, 0.8)', color: colorPrimary, borderColor: colorPrimary, borderRadius: 6}}
                  classNames={{
                    input: hasFreeVin ? styles['mqp-page-input'] : styles['mqp-page-input-2']
                  }}
                  value={vinInputKey}
                  cameraButtonStyle={{ color: colorPrimary, right: lang === 'ara' ? 'unset' : '80px', left: lang === 'ara' ? '80px' : 'unset' }}
                  enterButton={<Button type="primary" icon={<SearchOutlined/>} style={{width: 70,  borderColor: colorPrimary}}></Button>}
                  canSearchOe={true}
                />
              </ConfigProvider>
            </div>
            <div className={styles['ht-r']}>
              {
                localStorage.getItem('token') && (!localStorage.getItem('tourist_user')) ? <div className={styles['icon-btn']}>
                  <IMChat 
                    userInfo={commonStore.userInfo} 
                    title={intl.formatMessage({id: '聊天'})} 
                    enterButton={
                      <div className={styles['icon-btn-con']} style={{marginLeft: 0}}>
                        <i className='iconfont icon-Chat1' style={{fontSize: 24}}></i>
                        <span>{intl.formatMessage({id: '聊天'})}</span>
                      </div>
                    }
                  />
                </div> : <div className={styles['icon-btn']} onClick={() => navigate('/login')}>
                  <i className='iconfont icon-Chat1' style={{fontSize: 24}}></i>
                  <span>{intl.formatMessage({id: '聊天'})}</span>
                </div>
              }
              <div className={styles['icon-btn']} onClick={() => navigateTo('/epc')}>
                <i className='iconfont icon-a-Frame7' style={{fontSize: 24}}></i>
                <span>{intl.formatMessage({id: 'EPC'})}</span>
              </div>
              <div className={styles['icon-btn']} onClick={() => navigateTo('/mine/order')}>
                <i className='iconfont icon-geren' style={{fontSize: 24}}></i>
                <span>{intl.formatMessage({id: '个人'})}</span>
              </div>
              <Dropdown menu={{ items: langItems }}>
                <div className={styles['icon-btn']}>
                  <i className='iconfont icon-En-01' style={{fontSize: 24}}></i>
                  <span>
                    { lang === 'zh' ? '中文' 
                      : lang === 'en' ? 'English' 
                      : lang === 'ru' ? 'Русский язык' 
                      : lang === 'cht' ? '中文-繁體' 
                      : lang === 'tr' ? 'Türkiye' 
                      : lang === 'ara' ? 'بالعربية' 
                      : lang === 'pt' ? 'Português'
                      : lang === 'vie' ? 'Tiếng Việt' 
                      : lang === 'fra' ? 'French'
                      : lang === 'kor' ? '한국어' : '中文' }
                  </span>
                </div>
              </Dropdown>
              {
                commonStore.query_mode ? <div style={{marginLeft: 16}}>
                  <span>{intl.formatMessage({id: '发货仓'})}：</span>
                  <Dropdown menu={{items: merchantItems}}>
                    <div className='flex-s-c'>
                      <span>{merchantItem.erp_company}</span>
                      <i className="iconfont icon-down ml5" />
                    </div>
                  </Dropdown>
                </div> : null
              }
            </div>
          </div>
        </div>
        <div className={styles['hb-9']}>
          <div className={styles['nav-list']} style={{background: colorPrimary}}>
            <div className={styles['hb-nav-wrap']} style={{width: lang === 'zh' ? 1140 : (classList.length > 6 ? 1104 : 1140), maxWidth: lang === 'zh' ? '100%' : (classList.length > 6 ? 'calc(100% - 36px)' : '100%')}}>
              <div className={styles['hb-nav-list']} id="hb-nav-list">
                <div className={pathname === '/home' && !selClass ? `${styles['nav-item']} ${styles['active']}` : styles['nav-item']} style={{color: fontColorPrimary ? fontColorPrimary : '#FFFFFF'}} onClick={() => navigate('/home')} id="navPath0">{intl.formatMessage({id: '首页'})}</div>
                {
                  classList.map((item: any, index: number) => {
                    return (
                      <div  key={index} className={styles['classNav-item'] + " " + `${selClass === item ? styles['active'] : ''}`} id={`navPath${index + 1}`} style={{color: fontColorPrimary ? fontColorPrimary : '#FFFFFF'}} onClick={() => classItemClick(item, index)}>
                        {capitalizeFirstLetter(item)}
                      </div>
                    )
                  })
                }
              </div>
            </div>
            {
              lang !== 'zh' && classList.length > 6 ? <Dropdown
                menu={{ items: classItems }}
              >
                <div className={styles['nav-item']} style={{color: fontColorPrimary ? fontColorPrimary : '#FFFFFF'}}>
                  <i className="icon iconfont icon-gengduo3"/>
                </div>
              </Dropdown> : null
            }
          </div>
          {
            hasSecondClass && selClass ? <div className={styles['subNav-list']}>
              <div className={styles['hb-wrap']}>
                {
                  (groupClass[selClass] || []).map((str: string, i: number) => {
                    return (
                      <div key={i} className={styles['nav-subtab'] + " pointer " + `${selClass && secondClass === str ? styles['active'] : ''}`} style={{color: selClass && secondClass === str ? colorPrimary : '#333333'}} onClick={() => gotoClass({ title: selClass + ',' + str })}>{capitalizeFirstLetter(str)}</div>
                    )
                  })
                }
              </div>
            </div> : null
          }
        </div>
      </div>
    </>
  )
}

export default HeaderSix